class PkProgressbar extends HTMLElement {
    constructor() {
        super();
    }

    // Méthode appelée automatiquement lorsque l'élément est connecté au DOM
    connectedCallback() {
        this.free_shipping = this.querySelector('.free-shipping');
        this.shipping_number = this.querySelector('#free-shipping--number');
        this.amount_text = this.querySelector('.free-shipping--text span');
        this.free_message = this.querySelector('.free-message');
        this.start_message = this.querySelector('.free-shipping--text');

        this.total = parseInt(this.dataset.cartTotal, 10);
        this.minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));

        // Initialisation de la barre de progression
        this.updateFreeShippingBar();

        // Écoute l'événement cart:quantityChange
        document.addEventListener('cart:quantityChange', (event) => {
            const newTotal = event.detail.newTotal; // Récupère le nouveau total du panier
            this.total = newTotal;  // Mets à jour la propriété `total` avec le nouveau montant
            this.updateFreeShippingBar();  // Mets à jour la barre de progression
        });
    }

    // Méthode appelée automatiquement lorsque l'élément est retiré du DOM (utile pour nettoyer les événements)
    disconnectedCallback() {
        document.removeEventListener("DOMContentLoaded", this.updateFreeShippingBar);
        document.removeEventListener('cart:quantityChange', this.updateFreeShippingBar.bind(this));
    }

    updateFreeShippingBar() {

        if (this) {

            const percentage = Math.min(this.total / this.minimum, 1);
            const roundedPercentage = Math.round(percentage * 100);

            let color = '#d68228';
            if (percentage >= 1) {
                color = '#28d62b';
            } else if (percentage > 0.66) {
                color = '#b5d628';
            } else if (percentage > 0.33) {
                color = '#d6ab28';
            }

            // Applique le pourcentage et la couleur
            this.style.setProperty('--percentage', percentage);
            this.shipping_number.innerHTML = `${roundedPercentage}%`;
            this.querySelector('.free-shipping--percentage').style.backgroundColor = color;

            // Met à jour le texte du montant restant
            if (this.total < this.minimum) {
                const remaining = this.minimum - this.total;
                this.amount_text.innerHTML = this.formatMoney(remaining, '{{amount}}'); // Utilise une méthode de formatage
            } else {
                this.amount_text.innerHTML = ''; // Vide le texte si la livraison est gratuite
            }

            // Affiche ou masque le message selon le pourcentage
            if (percentage >= 1) {
                this.free_message.classList.remove('hidden');
                this.start_message.classList.add('hidden');
            } else {
                this.start_message.classList.remove('hidden');
                this.free_message.classList.add('hidden');
            }
        }
    }

    // Méthode pour formater l'argent
    formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }

        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholderRegex);

        if (!match) {
            console.error('Invalid format string:', format);
            return format;
        }

        const formatWithDelimiters = (number, precision = 2, thousands = '.', decimal = ',') => {
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            const parts = number.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '€1' + thousands);
            const cents = parts[1] ? (decimal + parts[1]) : '';
            return `${dollars}${cents} €`;
        };

        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            default:
                console.error('Unknown format type:', match[1]);
                return format;
        }

        return format.replace(placeholderRegex, value);
    }
}

customElements.define('progress-bar', PkProgressbar);